import { render } from "./ComisionPagos.vue?vue&type=template&id=6dd03f13"
import script from "./ComisionPagos.vue?vue&type=script&lang=js"
export * from "./ComisionPagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__